module.exports = __webpack_public_path__ + "src/img/zalando/zdt-ui-1.7d926.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/zdt-ui-1.jpg
// module id = 274
// module chunks = 0